import { render, staticRenderFns } from "./selectedCard.vue?vue&type=template&id=041262f8&"
import script from "./selectedCard.vue?vue&type=script&lang=js&"
export * from "./selectedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports